"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedProductMaterialWithoutInDetailResponse = exports.mockedProductMaterialResponse = void 0;
const omit_util_1 = require("../../utils/omit.util");
const color_option_1 = require("../color-option");
const country_1 = require("../country");
const measurement_1 = require("../measurement");
const option_1 = require("../option");
const product_in_detail_1 = require("../product-in-detail");
exports.mockedProductMaterialResponse = {
  id: 1,
  saleStartAt: new Date(),
  saleEndAt: null,
  measurement: measurement_1.mockedMeasurementResponse,
  originCountry: country_1.mockedCountryResponse,
  brandCountry: country_1.mockedCountryResponse,
  options: [option_1.mockedOptionResponse],
  colorOptions: [color_option_1.mockedColorOptionResponse],
  productInDetail: product_in_detail_1.mockedProductInDetailResponse,
  oldId: null
};
exports.mockedProductMaterialWithoutInDetailResponse = omit_util_1.omitObject(exports.mockedProductMaterialResponse, 'productInDetail');